define('presentation/signup/validators/signupForCustomerModalValidator',[
        'common/promises/promiseFactory',
        'common/specifications/validEmailAddressSpecification',
        'constants/validationMessageEnumerations',
        'presentation/common/validation/commonValidator',
        'presentation/common/validation/validationRule',
        'presentation/common/validation/validPatliveAccountNumberSpecification'
    ],
    function() {
        return function() {
            let self = this;

            const PromiseFactoryConstructor = require('common/promises/promiseFactory');
            const _promiseFactory = new PromiseFactoryConstructor();

            const ValidEmailAddressSpecificationConstructor = require('common/specifications/validEmailAddressSpecification');
            const _validEmailAddressSpecification = new ValidEmailAddressSpecificationConstructor();

            const ValidPatliveAccountNumberSpecificationConstructor = require('presentation/common/validation/validPatliveAccountNumberSpecification');
            let _validPatliveAccountNumberSpecification = new ValidPatliveAccountNumberSpecificationConstructor();

            const CommonValidatorConstructor = require('presentation/common/validation/commonValidator');
            const ValidationRulesConstructor = require('presentation/common/validation/validationRule');

            let _commonValidator = null;
            let _viewModel = null;
            let _facade = null;

            self.registerViewModel = (viewModel, facade) => {

                const validationRules = new ValidationRulesConstructor();
                validationRules.field("hubSpotContact")
                    .addValidationKeyUp(_isHubSpotContactValid)
                    .addValidationI18n(_isHubSpotContactValid, 'signupForCustomerModal:hubSpotContactRecordIdInvalid')
                    .addValidationI18n(_isEmailAddressAvailable, 'signupForCustomerModal:hubSpotContactEmailUnique');
                validationRules.field("patLiveAccountNumber")
                    .addValidationKeyUp(_isPatLiveAccountNumberValid)
                    .addValidationI18n(_isPatLiveAccountNumberValid, 'signupForCustomerModal:patLiveAccountNumberInvalid');

                _viewModel = viewModel;
                _facade = facade;
                _commonValidator = new CommonValidatorConstructor(_viewModel, validationRules);
            };

            self.validate = () => {
                return _commonValidator.validate();
            };

            const _isHubSpotContactValid = (hubSpotContact) => {
                const hubSpotContactRecordId = _viewModel.hubSpotContactRecordId();
                if (!hubSpotContactRecordId){
                    return true;
                }

                if (hubSpotContactRecordId && !hubSpotContact) {
                    return false;
                }

                if (hubSpotContact) {
                    const email = hubSpotContact.email();
                    const firstName = hubSpotContact.firstName();
                    const lastName = hubSpotContact.lastName();
                    return _commonValidator.isStringWithValue(email) && email !== "-" ||
                        _commonValidator.isStringWithValue(firstName) && firstName !== "-" ||
                        _commonValidator.isStringWithValue(lastName) && lastName !== "-";
                }
                return true;
            };

            const _isEmailAddressAvailable = (hubSpotContact) => {
                return _promiseFactory.deferIndefinitely((promise) => {
                    if (hubSpotContact) {
                        const email = hubSpotContact.email();
                        const additionalEmails = hubSpotContact.additionalEmails();
                        Promise.all(
                            [...additionalEmails, email].map((e) => {
                                return _validEmailAddressSpecification.isEmailAddressAvailable(e);
                            })
                        ).then((results) => {
                            const areAllEmailsAvailable = results.every((r) => r === true);
                            promise.resolve(areAllEmailsAvailable);
                        });
                    } else {
                        promise.resolve(true);
                    }
                });
            };

            const _isPatLiveAccountNumberValid = (patLiveAccountNumber) => {
                if (patLiveAccountNumber) {
                    return _validPatliveAccountNumberSpecification.isValidPatliveAccountNumber(patLiveAccountNumber);
                }
                return true;
            };
        };
    });
